module.exports = __webpack_public_path__ + "static/media/4.19.15d35645.png";